export default "__VITE_ASSET__5d997283__"